import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, UtensilsCrossed, Coffee, IceCream, Apple, Smartphone, Zap, RefreshCw, ShoppingCart, CalendarDays } from 'lucide-react';
const mainFeatures = [{
  emoji: '📖',
  text: '200+ recetas saludables y riquísimas para niños',
  bg: 'bg-violet-100',
  border: 'border-violet-300',
  iconColor: 'text-violet-600'
}, {
  emoji: '🍽️',
  text: 'Comidas principales: Milanesas, hamburguesas, pizza, empanadas',
  bg: 'bg-orange-100',
  border: 'border-orange-300',
  iconColor: 'text-orange-500'
}, {
  emoji: '☕',
  text: 'Desayunos y meriendas: Panquecitos, muffins, licuados',
  bg: 'bg-yellow-100',
  border: 'border-yellow-300',
  iconColor: 'text-yellow-600'
}, {
  emoji: '🍦',
  text: 'Postres saludables: Helados, brownies, gelatinas',
  bg: 'bg-pink-100',
  border: 'border-pink-300',
  iconColor: 'text-pink-500'
}, {
  emoji: '🍎',
  text: 'Snacks para el cole: Barritas, chips de vegetales',
  bg: 'bg-emerald-100',
  border: 'border-emerald-300',
  iconColor: 'text-emerald-600'
}, {
  emoji: '📱',
  text: 'Acceso desde celular y computadora',
  bg: 'bg-blue-100',
  border: 'border-blue-300',
  iconColor: 'text-blue-500'
}, {
  emoji: '⚡',
  text: 'Entrega inmediata por email',
  bg: 'bg-amber-100',
  border: 'border-amber-300',
  iconColor: 'text-amber-600'
}, {
  emoji: '♾️',
  text: 'Acceso de por vida + actualizaciones',
  bg: 'bg-indigo-100',
  border: 'border-indigo-300',
  iconColor: 'text-indigo-500'
}];
const bonuses = [{
  tag: 'BONUS 1',
  tagBg: 'bg-orange-500',
  emoji: '🛒',
  title: 'Lista de Compras Hacker',
  desc: 'No pierdas horas en el supermercado. Entrá y salí del súper en 15 minutos con los ingredientes exactos para todas tus recetas.',
  bg: 'from-orange-50 to-yellow-50',
  border: 'border-orange-300',
  shadow: 'shadow-orange-200'
}, {
  tag: 'BONUS 2',
  tagBg: 'bg-violet-600',
  emoji: '📋',
  title: 'Menú Semanal Imprimible',
  desc: 'Ya no tendrás que pensar todos los días qué cocinar. Pegalo en tu heladera y olvidate. Nutrición automática para toda la semana.',
  bg: 'from-violet-50 to-purple-50',
  border: 'border-violet-300',
  shadow: 'shadow-violet-200'
}, {
  tag: 'BONUS 3',
  tagBg: 'bg-amber-500',
  emoji: '🔄',
  title: 'Guía de Sustitutos Invisibles',
  desc: '¿A tu hijo no le gusta una cierta verdura? Usá esta guía para saber con qué otra verdura podés reemplazarla y lograr igual esa receta.',
  bg: 'from-amber-50 to-yellow-50',
  border: 'border-amber-300',
  shadow: 'shadow-amber-200'
}, {
  tag: 'BONUS 4',
  tagBg: 'bg-rose-500',
  emoji: '🧠',
  title: 'PDF Cero Berrinches en la Mesa',
  desc: '5 técnicas de psicología inversa para desarmar el drama y que tu hijo se siente a comer con curiosidad.',
  bg: 'from-rose-50 to-pink-50',
  border: 'border-rose-300',
  shadow: 'shadow-rose-200'
}, {
  tag: 'BONUS 5',
  tagBg: 'bg-emerald-500',
  emoji: '🍫',
  title: 'Postres con Superpoderes',
  desc: 'Brownies de legumbres y helados de palta. Nutrición total incluso en el momento del postre.',
  bg: 'from-emerald-50 to-green-50',
  border: 'border-emerald-300',
  shadow: 'shadow-emerald-200'
}];
export function PackSection() {
  return <section className="pt-20 pb-10 bg-white" data-id="element-233">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-234">
        {/* Title */}
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-4xl md:text-5xl font-extrabold text-gray-900 text-center mb-10" data-id="element-235">
          ¿Qué{' '}
          <span className="bg-gradient-to-r from-orange-500 via-violet-600 to-emerald-500 bg-clip-text text-transparent" data-id="element-236">
            incluye
          </span>{' '}
          este <span className="text-orange-500" data-id="element-237">pack</span>
          <span className="text-violet-600" data-id="element-238">?</span>
        </motion.h2>

        {/* Central Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="max-w-2xl mx-auto mb-12 rounded-2xl overflow-hidden shadow-xl border-4 border-violet-100" data-id="element-239">
          <img src="https://cdn.magicpatterns.com/uploads/txHSB1JyrWUY9nBUFN6YA3/ChatGPT_Image_24_feb_2026,_23_42_26.png" alt="Pack de recetas para niños con bonus incluidos" className="w-full object-cover" data-id="element-240" />
        </motion.div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-10" data-id="element-241">
          {mainFeatures.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.07
        }} whileHover={{
          y: -4,
          scale: 1.03
        }} className={`flex items-start gap-3 ${feature.bg} rounded-xl p-4 border ${feature.border} cursor-default transition-shadow hover:shadow-md`} data-id="element-242">
              <div className="shrink-0 text-2xl leading-none mt-0.5" data-id="element-243">
                {feature.emoji}
              </div>
              <p className={`text-sm font-semibold leading-snug ${feature.iconColor}`} data-id="element-244">
                {feature.text}
              </p>
            </motion.div>)}
        </div>

        {/* Bonus Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-245">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} whileHover={{
          y: -6,
          scale: 1.04
        }} className={`relative bg-gradient-to-br ${bonus.bg} border-2 ${bonus.border} rounded-2xl p-6 shadow-lg ${bonus.shadow} cursor-default`} data-id="element-246">
              <span className={`absolute -top-3 left-5 ${bonus.tagBg} text-white text-xs font-extrabold px-3 py-1 rounded-full uppercase tracking-widest shadow`} data-id="element-247">
                {bonus.tag}
              </span>
              <div className="text-4xl mb-3 mt-1" data-id="element-248">{bonus.emoji}</div>
              <h3 className="font-extrabold text-gray-900 text-lg mb-1" data-id="element-249">
                {bonus.title}
              </h3>
              <p className="text-gray-600 text-sm leading-snug" data-id="element-250">{bonus.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}